import { Flex } from "antd";
import i18next from "i18next";

import Card from "components/Card/Card";
import { formatCurrency } from "components/Utils/agGrid/valueFormatters";

type Props = {
  isLoadingFinancialData: boolean;
  distributorFinancialData: any;
};

const FinancialInfoCards = ({
  isLoadingFinancialData,
  distributorFinancialData,
}: Props) => {
  if (isLoadingFinancialData) return null;

  return (
    <Flex vertical style={{ width: "100%" }}>
      <Flex style={{ gap: 20, width: "100%" }}>
        <Card
          title={i18next.t("ttl_debt")}
          value={Number(formatCurrency(distributorFinancialData.inTermTotal)) || 0}
        />
        <Card
          title={i18next.t("ttl_debt_due")}
          value={Number(formatCurrency(distributorFinancialData.dueTotal)) || 0}
        />
        <Card
          title={i18next.t("ttl_balance")}
          value={Number(formatCurrency(distributorFinancialData.balanceTotal)) || 0}
        />
      </Flex>
    </Flex>
  );
};

export default FinancialInfoCards;
